import React from 'react';
import { type Moment } from 'moment';
import moment from 'moment-timezone';
import { withFormsy } from 'formsy-react';
import { styled, TextField, type TextFieldProps } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

import { type FilterItemBaseProps } from '../FilterItemManager';

const DateTextField = styled(TextField)<TextFieldProps>(({ theme }) => ({
	'& > .MuiOutlinedInput-root > .MuiOutlinedInput-input': {
		paddingTop: 12,
		paddingBottom: 12
	}
}));

function DateFilterItem({ sendChange, ...props }: FilterItemBaseProps<string>) {
	const isDisabled = !!props.defaultValue;

	const [value, setValue] = React.useState(props.value ?? null);

	const internalValue = React.useRef(props.value ? moment.utc(props.value) : null);

	const handleBlur = () => {
		const newValue = internalValue && internalValue.current?.isValid() ? internalValue.current?.utc() : undefined;
		sendChange(newValue?.toISOString());
	};

	const handleChange = (newValue: Moment | null) => {
		internalValue.current = newValue ? newValue.startOf('day').utc() : null;
		setValue(internalValue.current?.toISOString() || null);
	};

	return (
		<DatePicker
			className={props.className}
			format="DD/MM/YYYY"
			formatDensity="dense"
			value={value ? moment.utc(value) : null}
			slots={{ textField: DateTextField }}
			slotProps={{
				textField: {
					name: props.name,
					variant: 'outlined',
					size: 'small',
					fullWidth: true,
					autoComplete: 'off',
					placeholder: props.placeholder,
					slotProps: {
						input: { onBlur: handleBlur }
					}
				}
			}}
			timezone={moment.tz.guess()}
			disabled={isDisabled}
			onChange={handleChange}
			onClose={handleBlur}
			displayWeekNumber
			enableAccessibleFieldDOMStructure={false}
		/>
	);
}

export default React.memo(withFormsy(DateFilterItem));
